import { LoopscalePointsAction, useLoanMultipliersUtil, useRewardsPointsPerSecond } from "@bridgesplit/abf-react";
import { StatColumn, IconWithBackground, Icon } from "@bridgesplit/ui";
import { formatNum } from "@bridgesplit/utils";

import { CaptionWithIcon } from "../common";
import { useRewardTagColor } from "../util";

// Rewards daily points display supports loops

export interface RewardsCustomPointsProps {
    loopscalePointsAction: LoopscalePointsAction;
    identifier: string | undefined;
    customDailyPoints: number | undefined;
}
export function RewardsDailyCustomPoints({
    loopscalePointsAction,
    identifier,
    customDailyPoints
}: RewardsCustomPointsProps) {
    const { isLoading: loanMultipliersLoading } = useLoanMultipliersUtil();
    const { isLoading: rewardPointsPerSecondLoading } = useRewardsPointsPerSecond();

    const loading = loanMultipliersLoading || rewardPointsPerSecondLoading;

    const stats = [
        {
            caption: (
                <RewardsDailyCustomPointsCaption
                    loopscalePointsAction={loopscalePointsAction}
                    identifier={identifier}
                />
            ),
            value: formatNum(customDailyPoints),
            variant: "body2"
        }
    ];

    return <StatColumn stats={stats} loading={loading} />;
}

function RewardsDailyCustomPointsCaption({
    loopscalePointsAction,
    identifier
}: Omit<RewardsCustomPointsProps, "customDailyPoints">) {
    const { loanMultipliers } = useLoanMultipliersUtil();
    const tagColor = useRewardTagColor(loanMultipliers, identifier ? [identifier] : undefined, [loopscalePointsAction]);

    return (
        <CaptionWithIcon
            variant="body2"
            icon={
                <IconWithBackground tagColor={tagColor} size={20}>
                    <Icon type="points" />
                </IconWithBackground>
            }
            caption={`Daily points`}
        />
    );
}
